import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { theme } from '../../../styles/theme'

export const Container = styled.div`
  width: 100%;
  height: 100%;
`

export const Content = styled.div`
  width: 100%;
  padding: 0px 20px;

  display: flex;
  flex-direction: column;
  gap: 16px;

  @media (min-width: 768px) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    padding: 12px 100px 0px 100px;
  }
`

export const M = styled.div`
  margin: 0px;
`

export const BackButton = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;

  svg {
    path {
      fill: ${theme.colors.white};
    }
  }
`
export const Header = styled.div`
  width: 100%;
  padding: 24px 16px;
  background-color: ${theme.colors.green2};
  border-radius: 0px 0px 40px 40px;
  display: flex;
  justify-content: start;
  color: white;
  span {
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    margin-left: 5px;
  }
  @media (min-width: 768px) {
    padding: 40px 100px;
  }
`
